import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/home/20250415-180420.png';
var _withScopeId = function (n) {
  return _pushScopeId("data-v-310e8766"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "paper-mask-dialog-content"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("img", {
    width: "290",
    height: "232",
    src: _imports_0,
    alt: "tips",
    class: "tips-img"
  }, null, -1);
});
var _hoisted_3 = {
  class: "content-right"
};
var _hoisted_4 = {
  class: "content-title"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "ml8"
  }, "请认真答题", -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "content-desc"
  }, " 答题过程中，鼠标离开答题页会影响最终答题成绩，请尽快回到答题界面！ ", -1);
});
var _hoisted_7 = {
  class: "mt20"
};
var _hoisted_8 = /*#__PURE__*/_createTextVNode("去答题");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ExclamationCircleFilled = _resolveComponent("ExclamationCircleFilled");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.cheatService.maskVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.cheatService.maskVisible = $event;
    }),
    closable: false,
    "mask-closable": false,
    title: null,
    footer: null,
    header: null,
    width: "100%",
    "wrap-className": "full-modal"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_ExclamationCircleFilled, {
        style: {
          "color": "#ff8600",
          "font-size": "20px"
        }
      }), _hoisted_5]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_a_button, {
        type: "primary",
        shape: "round",
        onClick: _ctx.cheatService.reback
      }, {
        default: _withCtx(function () {
          return [_hoisted_8];
        }),
        _: 1
      }, 8, ["onClick"])])])])];
    }),
    _: 1
  }, 8, ["visible"]);
}